import { useState } from "react";

import InventoryItem from "./InventoryItem";

import ReactPaginate from "react-paginate";

export default function InventoryContent({
  inventoryData,
  inventoryListTotal,
  setUpdater,
  inventoryListFunc,
  setOpenModal,
  setSelectedRecord,
  pagination,
  setPagination,
}) {
  return (
    <div>
      {inventoryData.map((value) => (
        <InventoryItem
          data={value}
          setUpdater={setUpdater}
          setOpenModal={setOpenModal}
          setSelectedRecord={setSelectedRecord}
        />
      ))}
      <div className=" d-flex justify-content-center mt-3">
        <ReactPaginate
          forcePage={pagination - 1}
          previousLabel={"<"}
          nextLabel={">"}
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageCount={Math.ceil(inventoryListTotal / 10)}
          marginPagesDisplayed={1}
          pageRangeDisplayed={1}
          onPageChange={(e) => {
            setPagination(e.selected + 1);
            inventoryListFunc(e.selected + 1);
          }}
          containerClassName="pagination mx-auto mb-3"
          activeLinkClassName="text-white"
          activeClassName="bg-info style-activeClass"
          pageClassName="style-pageClass mx-2 border border-1"
          pageLinkClassName="page-link style-page-link"
          nextClassName="border btn mx-1 px-4 py-1 "
          previousClassName="border btn mx-1 px-4 py-1  "
          nextLinkClassName="style-nextLink "
          previousLinkClassName="style-previousLink "
        />
      </div>
    </div>
  );
}
